import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { Icon, Button } from "@lifepay/rc-ui-toolkit";
// import { format } from "date-fns";

import profileSVG from "@lifepay/assets/sprites/icomoon/shop.svg";

import styles from "./Company.m.scss";

function Company(props) {
  const { theme, company, continueWork, endWork } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.inner)}>
        <div className={classnames(theme.header)}>
          <div className={classnames(theme.client)}>
            <Icon
              sprite={profileSVG}
              theme={{
                wrapper: theme["profile-icon"],
              }}
            />
            <div className={classnames(theme.name)}>
              {company.companyName || company.companyFullName || company.inn}
            </div>
          </div>
        </div>
        <div className={classnames(theme.controls)}>
          <Button
            type={"alt"}
            size={"small"}
            onClick={() => endWork({ id: company.companyId, type: "COMPANY" })}
          >
            {"Завершить"}
          </Button>
          <Button
            type={"main"}
            size={"small"}
            onClick={() =>
              continueWork({ id: company.companyId, type: "COMPANY" })
            }
          >
            {"Продолжить"}
          </Button>
        </div>
      </div>
    </div>
  );
}

Company.displayName = "Company";

Company.propTypes = {
  theme: PropTypes.object,
  company: PropTypes.object.isRequired,
  continueWork: PropTypes.func.isRequired,
  endWork: PropTypes.func.isRequired,
};

Company.defaultProps = {};

export default themr("@lifepay/Company", styles)(Company);



// WEBPACK FOOTER //
// ./src/components/emission/client-summary/Company/Company.js